import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import ABSelect from "./ABSelect";
import {
  removeProfRef, 
  saveProfRef,
  deleteSaveProfReferenceDetails,
} from "../../Actions/professionalReferenceActions";
import { useDispatch, useSelector } from "react-redux";
import GetMasterData from "../../Helper/masterData";
import ABDate from "./ABDate";
import ABText from "../Common/ABText";
import "../../assets/css/custom-modal.css";
import "../../assets/css/rec-carousel.css";
import {
  validateEmail,
  validateMobileNumber,
  validateMobileNumber711,
} from "../../Helper/common";
import _ from "lodash";
import Loader from "../Common/loader";
import { useNavigate } from "react-router-dom";
import ABRadioProfRef1 from "./ABRadioProfRef1";
import ABRadioProfRef2 from "./ABRadioProfRef2";
import { getData } from "../../Actions/landingAction";
import ConfirmationPopup from "./confirmationPopup";

const MainForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    profReference,
    active,
    reference,
    showAddPopup,
    closeAddPopup,
    proceedAdd,
    checkStatus,
  } = props;
  const [professioalReference, setProfReference] = useState([]);
  const [referenceData1, setProfReference1] = useState([]);
  const [referenceData2, setProfReference2] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { bestTimeToReachOptions } = GetMasterData();
  const [bestTimeToReach, setBestTime] = useState({});
  const [newRecord, setNewRecord] = useState({});
  const [newRecord1, setNewRecord1] = useState({});
  const [newValidationRecord, setNewValidationRecord] = useState({});
  const [formError, setFormError] = useState({});
  const [clientId,setClientId]=useState();
  const storeData = useSelector((state) => state.profReference);
  const {
    profReferenceData,
    loading: getLoad,
    error: addLoadError,
  } = storeData;
  const [maxDate, setMaxDate] = useState(null);
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [checkIdToBeRemoved, setCheckIdToBeRemoved] = useState(null);

  useEffect(() => {
    //setProfReference(profReference);
    setProfReference1(profReference.profRefDetails_ref1);
    setProfReference2(profReference.profRefDetails_ref2);
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    setClientId(userLocalData?.bridge_client_id  || userLocalData?.client_id);

  }, [profReference]);

  useEffect(() => {
    const isEmpComp = profReferenceData.message ? true : false;
    if (isEmpComp) {
      navigate(`/case-initiation/check-detail/${reference}/4`);
    }
    if (
      typeof profReference.data !== "undefined" &&
      profReference.data !== null
    ) {
      setProfReference(profReference);
      setProfReference1(profReference.profRefDetails_ref1);
      setProfReference2(profReference.profRefDetails_ref2);
    } else {
    }
  }, [profReference, profReferenceData]);

  useEffect(() => {
    let obj = {};
    for (var i in bestTimeToReachOptions) {
      obj[bestTimeToReachOptions[i].value] = bestTimeToReachOptions[i].label;
    }
    setBestTime(obj);
  }, [bestTimeToReachOptions]);

  useEffect(() => {
    if (typeof getLoad !== "undefined" && getLoad !== null) {
      if (getLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getLoad]);
  //select option handler for getting the information of fileds thats is formatted as per the api format
  const selectHandler = (value) => {
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    if (
      value[0].name == "reference_email_" + value[0].caseId ||
      value[0].name == "reference_email_1_" + value[0].caseId
    ) {
      let elementValue = value[0].value;
      let elementErrorId = "";
      if (value[0].name == "reference_email_" + value[0].caseId) {
        elementErrorId = "err_" + value[0].caseId + "_" + value[0].fieldId;
      } else {
        elementErrorId =
          "err_" + value[0].caseId + "_" + value[0].fieldId + "_1";
      }
      if (
        elementValue === undefined ||
        elementValue === null ||
        elementValue == ""
      ) {
      } else {
        let elementValue1 = validateEmail(elementValue);
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid email id";
        } else {
          document.getElementById(elementErrorId).innerHTML = "";
        }
      }
    }

    if (
      value[0].name == "reference_mobile_" + value[0].caseId ||
      value[0].name == "reference_mobile_1_" + value[0].caseId
    ) {
      let elementValue = value[0].value;
      let elementErrorId = "";
      if (value[0].name == "reference_mobile_" + value[0].caseId) {
        elementErrorId = "err_" + value[0].caseId + "_" + value[0].fieldId;
      } else {
        elementErrorId =
          "err_" + value[0].caseId + "_" + value[0].fieldId + "_1";
      }
      if (
        elementValue === undefined ||
        elementValue === null ||
        elementValue == ""
      ) {
      } else {
        let elementValue1 = validateMobileNumber711(elementValue);
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid mobile number";
        } else {
          document.getElementById(elementErrorId).innerHTML = "";
        }
      }
    }
    if (
      value[0].name ==
        "selectedOption_reference_level_1_" + value[0].caseCheckId ||
      value[0].name == "reference_name_1_" + value[0].caseId ||
      value[0].name == "reference_designation_1_" + value[0].caseId ||
      value[0].name == "reference_email_1_" + value[0].caseId ||
      value[0].name == "reference_mobile_1_" + value[0].caseId ||
      value[0].name == "reference_best_time_to_reach_1_" + value[0].caseCheckId
    ) {
      setNewRecord1((prevState) => ({
        ...prevState,
        [value[0].fieldId]: value[0].value,
      }));
    } else {
      console.log(value[0].value)
      // debugger
      setNewRecord((prevState) => ({
        ...prevState,
        [value[0].fieldId]: value[0].value,
      }));
    }
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  //form validation logic
  const formValidation = (caseCheckId, activeTabIndex) => {
    const errors = {};
    let isError = false;

    let activeTab = activeTabIndex - 1;
    let case_check_id = profReference.checksDetails[activeTab].case_check_id;
    let field_company_name =
      profReference.checksDetails[activeTab].fields.company_name;
    if (field_company_name.is_mandatory == 1) {
      let fieldId = field_company_name.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "company_name_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }
    }
    let field_company_designation =
      profReference.checksDetails[activeTab].fields.company_designation;
    if (field_company_designation.is_mandatory == 1) {
      let fieldId = field_company_designation.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "company_designation_" + case_check_id;
      let elementExists = document.getElementById(elementName);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName).value == null ||
          document.getElementById(elementName).value == ""
        ) {
          let elementValue = newValidationRecord[elementName];
          if (elementValue === undefined || elementValue === null) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
        }
      }
    }
    let field_company_department =
      profReference.checksDetails[activeTab].fields.company_department;
    if (field_company_department.is_mandatory == 1) {
      let fieldId = field_company_department.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "company_department_" + case_check_id;
      let elementExists = document.getElementById(elementName);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName).value == null ||
          document.getElementById(elementName).value == ""
        ) {
          let elementValue = newValidationRecord[elementName];
          if (elementValue === undefined || elementValue === null) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
        }
      }
    }
    let field_company_date_joining =
      profReference.checksDetails[activeTab].fields.company_date_joining;
    if (field_company_date_joining.is_mandatory == 1) {
      let fieldId = field_company_date_joining.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "company_date_joining_" + case_check_id;
      let elementExists = document.getElementById(elementName);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName).value == null ||
          document.getElementById(elementName).value == ""
        ) {
          let elementValue = newValidationRecord[elementName];
          if (elementValue === undefined || elementValue === null) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
        }
      }
    }
    let field_company_date_of_leaving =
      profReference.checksDetails[activeTab].fields.company_date_of_leaving;
    if (field_company_date_of_leaving.is_mandatory == 1) {
      let fieldId = field_company_date_of_leaving.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "company_date_of_leaving_" + case_check_id;
      let elementExists = document.getElementById(elementName);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName).value == null ||
          document.getElementById(elementName).value == ""
        ) {
          let elementValue = newValidationRecord[elementName];
          if (elementValue === undefined || elementValue === null) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
        }
      }
    }
    let field_reference_level =
      profReference.checksDetails[activeTab].fields.reference_level;
    if (field_reference_level.is_mandatory == 1) {
      let fieldId = field_reference_level.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_level_" + case_check_id;
      if(clientId != "394129"){
      let peer_check = document.getElementsByName(elementName)[0].checked;
      let senior_check = document.getElementsByName(elementName)[1].checked;
      if (peer_check == false && senior_check == false) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        setNewRecord((prevState = {}) => ({
          ...prevState,
          [fieldId]: peer_check == true ? "Peer" : "Senior",
        }));
      }
    }
      let fieldId1 = field_reference_level.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_level_1_" + case_check_id;
      let elementExists = document.getElementsByName(elementName1)[0];
      
      if(clientId != "394129"){
      if (typeof elementExists != "undefined" && elementExists != null) {
        if(clientId != "394129"){
        let peer_check1 = document.getElementsByName(elementName1)[0].checked;
        let senior_check1 = document.getElementsByName(elementName1)[1].checked;
        if (peer_check1 == false && senior_check1 == false) {
          let elementValue1 = newValidationRecord[elementName1];
          if (elementValue1 === undefined || elementValue1 === null) {
            document.getElementById(elementErrorId1).innerHTML =
              "This field is required.";
            isError = true;
          }
        } else {
          setNewRecord1((prevState = {}) => ({
            ...prevState,
            [fieldId]: peer_check1 == true ? "Peer" : "Senior",
          }));
        }
      }
    }
  }

  }
    let field_reference_name =
      profReference.checksDetails[activeTab].fields.reference_name;
    if (field_reference_name.is_mandatory == 1) {
      let fieldId = field_reference_name.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_name_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        console.log(elementName);
        setNewRecord((prevState = {}) => ({
          ...prevState,
          [fieldId]: document.getElementById(elementName).value,
        }));
      }
      let fieldId1 = field_reference_name.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_name_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName1).value == null ||
          document.getElementById(elementName1).value == ""
        ) {
          let elementValue1 = newValidationRecord[elementName1];
          if (elementValue1 === undefined || elementValue1 === null) {
            document.getElementById(elementErrorId1).innerHTML =
              "This field is required.";
            isError = true;
          }
        } else {
          setNewRecord1((prevState = {}) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName1).value,
          }));
        }
      }
    } else {
      let fieldId = field_reference_name.id;
      let elementName = "reference_name_" + case_check_id;
      
      console.log(elementName);
      setNewRecord((prevState = {}) => ({
        ...prevState,
        [fieldId]: document.getElementById(elementName).value,
      }));
      let elementName1 = "reference_name_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        setNewRecord1((prevState = {}) => ({
          ...prevState,
          [fieldId]: document.getElementById(elementName1).value,
        }));
      }
    }
    let field_reference_designation =
      profReference.checksDetails[activeTab].fields.reference_designation;
    if (field_reference_designation.is_mandatory == 1) {
      let fieldId = field_reference_designation.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_designation_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        setNewRecord((prevState = {}) => ({
          ...prevState,
          [fieldId]: document.getElementById(elementName).value,
        }));
      }
      let fieldId1 = field_reference_designation.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_designation_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName1).value == null ||
          document.getElementById(elementName1).value == ""
        ) {
          let elementValue1 = newValidationRecord[elementName1];
          if (elementValue1 === undefined || elementValue1 === null) {
            document.getElementById(elementErrorId1).innerHTML =
              "This field is required.";
            isError = true;
          }
        } else {
          setNewRecord1((prevState = {}) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName1).value,
          }));
        }
      }
    } else {
      let fieldId = field_reference_designation.id;
      let elementName = "reference_designation_" + case_check_id;
      setNewRecord((prevState = {}) => ({
        ...prevState,
        [fieldId]: document.getElementById(elementName).value,
      }));
      let elementName1 = "reference_designation_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        setNewRecord1((prevState = {}) => ({
          ...prevState,
          [fieldId]: document.getElementById(elementName1).value,
        }));
      }
    }
    let field_reference_email =
      profReference.checksDetails[activeTab].fields.reference_email;
    if (field_reference_email.is_mandatory == 1) {
      console.log("dfgdfg");
      let fieldId = field_reference_email.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_email_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        } else {
          let elementValue1 = validateEmail(elementValue);
          if (elementValue1 == false) {
            document.getElementById(elementErrorId).innerHTML =
              "Please enter a valid email id";
            isError = true;
          } else {
            setNewRecord((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName).value,
            }));
          }
        }
      } else {
        let elementValue1 = validateEmail(
          document.getElementById(elementName).value
        );
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid email id";
          isError = true;
        } else {
          setNewRecord((prevState = {}) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName).value,
          }));
        }
      }

      let fieldId1 = field_reference_email.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_email_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName1).value == null ||
          document.getElementById(elementName1).value == ""
        ) {
          let elementValue1 = newValidationRecord[elementName1];
          if (elementValue1 === undefined || elementValue1 === null) {
            document.getElementById(elementErrorId1).innerHTML =
              "This field is required.";
            isError = true;
          } else {
            let elementValue2 = validateEmail(elementValue1);
            if (elementValue2 == false) {
              document.getElementById(elementErrorId1).innerHTML =
                "Please enter a valid email id";
              isError = true;
            } else {
              setNewRecord1((prevState = {}) => ({
                ...prevState,
                [fieldId]: document.getElementById(elementName1).value,
              }));
            }
          }
        } else {
          let elementValue1 = validateEmail(
            document.getElementById(elementName1).value
          );
          if (elementValue1 == false) {
            document.getElementById(elementErrorId1).innerHTML =
              "Please enter a valid email id";
            isError = true;
          } else {
            setNewRecord1((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName1).value,
            }));
          }
        }
      }
    } else {
      let fieldId = field_reference_email.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_email_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (
          elementValue === undefined ||
          elementValue === null ||
          elementValue == ""
        ) {
        } else {
          let elementValue1 = validateEmail(elementValue);
          if (elementValue1 == false) {
            document.getElementById(elementErrorId).innerHTML =
              "Please enter a valid email id";
            isError = true;
          } else {
            setNewRecord((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName).value,
            }));
          }
        }
      } else {
        let elementValue1 = validateEmail(
          document.getElementById(elementName).value
        );
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid email id";
          isError = true;
        } else {
          setNewRecord((prevState = {}) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName).value,
          }));
        }
      }
      let fieldId1 = field_reference_email.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_email_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName1).value == null ||
          document.getElementById(elementName1).value == ""
        ) {
          let elementValue1 = newValidationRecord[elementName1];
          if (
            elementValue1 === undefined ||
            elementValue1 === null ||
            elementValue1 == ""
          ) {
          } else {
            let elementValue2 = validateEmail(elementValue1);
            if (elementValue2 == false) {
              document.getElementById(elementErrorId1).innerHTML =
                "Please enter a valid email id";
              isError = true;
            } else {
              setNewRecord1((prevState = {}) => ({
                ...prevState,
                [fieldId]: document.getElementById(elementName1).value,
              }));
            }
          }
        } else {
          let elementValue1 = validateEmail(
            document.getElementById(elementName1).value
          );
          if (elementValue1 == false) {
            document.getElementById(elementErrorId1).innerHTML =
              "Please enter a valid email id";
            isError = true;
          } else {
            setNewRecord1((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName1).value,
            }));
          }
        }
      }
    }
    let field_reference_mobile =
      profReference.checksDetails[activeTab].fields.reference_mobile;
    if (field_reference_mobile.is_mandatory == 1) {
      let fieldId = field_reference_mobile.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_mobile_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        } else {
          let elementValue1 = validateMobileNumber711(elementValue);
          if (elementValue1 == false) {
            document.getElementById(elementErrorId).innerHTML =
              "Please enter a valid mobile number";
            isError = true;
          } else {
            setNewRecord((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName).value,
            }));
          }
        }
      } else {
        let elementValue1 = validateMobileNumber711(
          document.getElementById(elementName).value
        );
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid mobile number";
          isError = true;
        } else {
          setNewRecord((prevState = {}) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName).value,
          }));
        }
      }

      let fieldId1 = field_reference_mobile.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_mobile_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName1).value == null ||
          document.getElementById(elementName1).value == ""
        ) {
          let elementValue1 = newValidationRecord[elementName1];
          if (elementValue1 === undefined || elementValue1 === null) {
            document.getElementById(elementErrorId1).innerHTML =
              "This field is required.";
            isError = true;
          } else {
            let elementValue1 = validateMobileNumber711(elementValue1);
            if (elementValue1 == false) {
              document.getElementById(elementErrorId1).innerHTML =
                "Please enter a valid mobile number";
              isError = true;
            } else {
              setNewRecord1((prevState = {}) => ({
                ...prevState,
                [fieldId]: document.getElementById(elementName1).value,
              }));
            }
          }
        } else {
          let elementValue1 = validateMobileNumber711(
            document.getElementById(elementName1).value
          );
          if (elementValue1 == false) {
            document.getElementById(elementErrorId1).innerHTML =
              "Please enter a valid mobile number";
            isError = true;
          } else {
            setNewRecord1((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName1).value,
            }));
          }
        }
      }
    } else {
      let fieldId = field_reference_mobile.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_mobile_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (
          elementValue === undefined ||
          elementValue === null ||
          elementValue == ""
        ) {
        } else {
          let elementValue1 = validateMobileNumber711(elementValue);
          if (elementValue1 == false) {
            document.getElementById(elementErrorId).innerHTML =
              "Please enter a valid mobile number";
            isError = true;
          } else {
            setNewRecord((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName).value,
            }));
          }
        }
      } else {
        let elementValue1 = validateMobileNumber711(
          document.getElementById(elementName).value
        );
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid mobile number";
          isError = true;
        } else {
          setNewRecord((prevState = {}) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName).value,
          }));
        }
      }
      let fieldId1 = field_reference_mobile.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_mobile_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName1).value == null ||
          document.getElementById(elementName1).value == ""
        ) {
          let elementValue1 = newValidationRecord[elementName1];
          if (
            elementValue1 === undefined ||
            elementValue1 === null ||
            elementValue1 == ""
          ) {
          } else {
            // let elementValue2 = validateEmail(elementValue1);
            let elementValue2 = validateMobileNumber711(elementValue1);
            if (elementValue2 == false) {
              document.getElementById(elementErrorId1).innerHTML =
                "Please enter a valid mobile number";
              isError = true;
            } else {
              setNewRecord1((prevState = {}) => ({
                ...prevState,
                [fieldId]: document.getElementById(elementName1).value,
              }));
            }
          }
        } else {
          let elementValue1 = validateMobileNumber711(
            document.getElementById(elementName1).value
          );
          if (elementValue1 == false) {
            document.getElementById(elementErrorId1).innerHTML =
              "Please enter a valid mobile number";
            isError = true;
          } else {
            setNewRecord1((prevState = {}) => ({
              ...prevState,
              [fieldId]: document.getElementById(elementName1).value,
            }));
          }
        }
      }
    }
    let field_best_time =
      profReference.checksDetails[activeTab].fields
        .reference_best_time_to_reach;
    if (field_best_time.is_mandatory == 1) {
      let fieldId = field_best_time.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "reference_best_time_to_reach_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        setNewRecord((prevState) => ({
          ...prevState,
          [fieldId]: document.getElementsByName(elementName)[0].value,
        }));
      }
      let fieldId1 = field_best_time.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "reference_best_time_to_reach_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        if (
          document.getElementById(elementName1).value == null ||
          document.getElementById(elementName1).value == ""
        ) {
          let elementValue1 = newValidationRecord[elementName1];
          if (elementValue1 === undefined || elementValue1 === null) {
            document.getElementById(elementErrorId1).innerHTML =
              "This field is required.";
            isError = true;
          }
        } else {
          setNewRecord1((prevState) => ({
            ...prevState,
            [fieldId]: document.getElementsByName(elementName1)[0].value,
          }));
        }
      }
    } else {
      let fieldId = field_best_time.id;
      let elementName = "reference_best_time_to_reach_" + case_check_id;
      setNewRecord((prevState = {}) => ({
        ...prevState,
        [fieldId]: document.getElementsByName(elementName)[0].value,
      }));
      let elementName1 = "reference_best_time_to_reach_1_" + case_check_id;
      let elementExists = document.getElementById(elementName1);
      if (typeof elementExists != "undefined" && elementExists != null) {
        setNewRecord1((prevState = {}) => ({
          ...prevState,
          [fieldId]: document.getElementsByName(elementName1)[0].value,
        }));
      }
    }

    return isError;
  };

  const addProfRefStoreData = useSelector((state) => state.profRefAdd);
  const {
    profRefData,
    loading: getLoading,
    error: addError,
  } = addProfRefStoreData;

  const [profRefAddedState, setProfRefAddedState] = useState();

  useEffect(() => {
    if (typeof profRefData.data !== "undefined" && profRefData.data !== null) {
      navigate(`/case-initiation/check-detail/${reference}/5`);
    }
  }, [profRefData]);

  useEffect(() => {
    if (typeof getLoading !== "undefined" && getLoading !== null) {
      if (getLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getLoading]);

  useEffect(() => {
    if (profRefAddedState === 1) {
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove("active");
      }
      let tabLength = parseInt(tabs.length);
      tabs[tabLength - 1].classList.add("active");
      var pane = document.getElementsByClassName("tab-pane fade");
      for (let i = 0; i < pane.length; i++) {
        pane[i].classList.remove("active");
        pane[i].classList.remove("show");
      }
      let paneLength = parseInt(pane.length);
      pane[paneLength - 1].classList.add("active");
      pane[paneLength - 1].classList.add("show");
      setProfRefAddedState(0);
    }
  }, [profRefAddedState, addProfRefStoreData]);

  const storeRefRemove = useSelector((state) => state.profRefRemove);
  const { profRefRemoveData } = storeRefRemove;

  useEffect(() => {
    if (
      typeof profRefRemoveData !== "undefined" &&
      profRefRemoveData !== null
    ) {
      navigate(`/case-initiation/check-detail/${reference}/5`);
      dispatch(getData());
    }
  }, [profRefRemoveData, storeRefRemove]);

  const reRenderAgain = () => {
    props.reRenderAgain();
  };

  const tabChange = (index, caseCheckId) => {
    if (
      typeof profReference.checksDetails !== "undefined" &&
      profReference.checksDetails !== null
    ) {
      const reference = profReference.referenceNo;
      if (caseCheckId) {
        let refData11 = referenceData1;
        let refData1 = "";
        if (typeof refData11 !== "undefined" && refData11 != null) {
          refData1 = refData11[caseCheckId];
          if (typeof refData1 !== "undefined" && refData1 != null) {
            Object.entries(refData1).map(([key, value]) => {
              setNewRecord((prevState = {}) => ({
                ...prevState,
                [value[0].field_id]: value[0].stated_data,
              }));
            });
          }
        }
        if (
          index == 0 ||
          (index == 1 &&
            profReference.isCurrent == 1 &&
            profReference.checksDetails[index].is_added != 1)
        ) {
          let refData12 = referenceData2;
          let refData2 = "";
          if (typeof refData12 !== "undefined" && refData12 != null) {
            refData2 = refData12[caseCheckId];
            if (typeof refData2 !== "undefined" && refData2 != null) {
              Object.entries(refData2).map(([key, value]) => {
                setNewRecord1((prevState = {}) => ({
                  ...prevState,
                  [value[1].field_id]: value[1].stated_data,
                }));
              });
            }
          }
        } else {
          setNewRecord1("");
        }
        navigate(`/case-initiation/check-detail/${reference}/5/${caseCheckId}`);
      }
    }
  };

  useEffect(() => {
    if (
      typeof profReference.checksDetails !== "undefined" &&
      profReference.checksDetails !== null
    ) {
      let activeTab = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          activeTab = tabs[i].dataset.index;
        }
      }

      if (activeTab == 0) {
        let caseCheckId = profReference.checksDetails[0].case_check_id;
        let refData11 = profReference.profRefDetails_ref1;
        let refData12 = profReference.profRefDetails_ref2;
        let refData1 = "";
        let refData2 = "";
        if (typeof refData11 !== "undefined" && refData11 != null) {
          refData1 = refData11[caseCheckId];
          if (typeof refData1 !== "undefined" && refData1 != null) {
            Object.entries(refData1).map(([key, value]) => {
              setNewRecord((prevState = {}) => ({
                ...prevState,
                [value[0].field_id]: value[0].stated_data,
              }));
            });
          }

          if (typeof refData12 !== "undefined" && refData12 != null) {
            refData2 = refData12[caseCheckId];
            if (typeof refData2 !== "undefined" && refData2 != null) {
              Object.entries(refData2).map(([key, value]) => {
                setNewRecord1((prevState = {}) => ({
                  ...prevState,
                  [value[1].field_id]: value[1].stated_data,
                }));
              });
            }
          }
        }
      }

      let today = new Date();
      setMaxDate(today);
    }
  }, [profReference]);

  useEffect(() => {
    if (
      typeof profReference.checksDetails !== "undefined" &&
      profReference.checksDetails !== null
    ) {
      let foundIndex = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          const dataCaseCh = tabs[i].dataset.casecheckid;
          if (dataCaseCh == active) {
            foundIndex = tabs[i].dataset.index;
          }
        }
      }
      if (active !== null && active !== undefined && foundIndex !== null) {
        tabChange(foundIndex, active);
      }
    }
  }, [profReference]);

  // form save hansler
  const saveHandler = async(event, caseCheckId, activetabIndex) => {
    event.preventDefault();
    // console.log(newRecord);
    //   debugger
    const err = formValidation(caseCheckId, activetabIndex);
    if (err === true) {
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      const recordData = {};
      recordData.case_check_id = caseCheckId;
      let company_name = document.getElementById(
        "company_name_" + caseCheckId
      ).value;
      let company_data = "";
      if (
        typeof document.getElementById("company_designation_" + caseCheckId) !==
          "undefined" &&
        document.getElementById("company_designation_" + caseCheckId) != null
      ) {
        let company_desig = document.getElementById(
          "company_designation_" + caseCheckId
        ).value;
        let company_dept = document.getElementById(
          "company_department_" + caseCheckId
        ).value;
        let company_date_join = document.getElementById(
          "company_date_joining_" + caseCheckId
        ).value;
        let company_date_leave = document.getElementById(
          "company_date_of_leaving_" + caseCheckId
        ).value;
        company_data = {
          16: company_name,
          17: company_desig,
          25: company_dept,
          21: company_date_join,
          22: company_date_leave,
        };
      } else {
        company_data = {
          16: company_name,
        };
      }

      const obj = {
        group: "reference",
        data: {
          company_data: { ...company_data },
          1: { ...newRecord },
          2: { ...newRecord1 },
        },
      };
      recordData.check_data = { [caseCheckId]: obj };
     let result=await dispatch(saveProfRef(recordData));
     if(result.status == "success"){
      setNewRecord({});
     }
      reRenderAgain();
    }
  };

  const storeData2 = useSelector((state) => state.profRefSave);
  const {
    profRefSaveData,
    loading: saveLoading,
    error: saveError,
  } = storeData2;
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [saveLoading]);

  useEffect(() => {
    if (
      typeof profRefSaveData !== "undefined" &&
      profRefSaveData !== null &&
      profRefSaveData.length != 0
    ) {
      const group = profRefSaveData.group ? profRefSaveData.group.group_id : "";
      const hasNextCheck = profRefSaveData.nextCheck != "" ? true : false;
      const reference = profRefSaveData.reference_number;
      if (!hasNextCheck) {
        if (group == "profile_preview") {
          navigate(`/case-initiation/profile-preview/${reference}`);
          dispatch(deleteSaveProfReferenceDetails());
        } else if (typeof group != "undefined" && group != "") {
          navigate(`/case-initiation/check-detail/${reference}/${group}`);
          dispatch(deleteSaveProfReferenceDetails());
        }
      } else {
        navigate(
          `/case-initiation/check-detail/${reference}/5/${profRefSaveData.nextCheck}`
        );
        dispatch(deleteSaveProfReferenceDetails());
        reRenderAgain();
        window.scrollTo(0, 0);
      }
    }
  }, [profRefSaveData, storeData2]);

  const closeRemovePopup = () => {
    setShowRemovePopup(false);
  };

  const proceedRemove = () => {
    if (checkIdToBeRemoved) {
      dispatch(removeProfRef(checkIdToBeRemoved));
      reRenderAgain();
      setCheckIdToBeRemoved(null);
      setShowRemovePopup(false);
    }
  };

  const handleProfRefRemoveClick = (e, caseCheckId) => {
    e.preventDefault();
    setCheckIdToBeRemoved(caseCheckId);
    setShowRemovePopup(true);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  return (
    <>
      {isLoading && <Loader />}
      {showAddPopup == true && checkStatus != 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Professional Reference"
          description="Are you sure you want to add another Professional Reference?"
          proceedHandler={proceedAdd}
          isAdd={true}
          checkStatus={checkStatus}
        />
      )}
      {showAddPopup == true && checkStatus == 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Professional Reference"
          description="Save the existing professional reference, before adding a new one"
          proceedHandler={proceedAdd}
          isAdd={false}
          checkStatus={checkStatus}
        />
      )}
      {showRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemovePopup}
          title="Remove Professional Reference"
          description="Are you sure you want to remove this professional reference?"
          proceedHandler={proceedRemove}
          isAdd={false}
        />
      )}
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {profReference.checksDetails &&
            Object.entries(profReference.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == caseCheckId) {
                  activeClass = "active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }
              let check_name = value.IB_CHECK_NAME;
              const caseCheckStatus = value.check_status;
              let completeClass = "";
              if (caseCheckStatus === 2) {
                completeClass = "completed";
              }
              return (
                <li className={`nav-item ${completeClass}`} key={key}>
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`profRef-tab-${index}`}
                    data-toggle="tab"
                    href={`#profRef-${index}`}
                    role="tab"
                    aria-controls={`profRef-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-casecheckid={caseCheckId}
                    onClick={() => tabChange(key, caseCheckId)}
                  >
                    {caseCheckStatus === 2 && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    {check_name}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      <hr />
      <div className="tab-content" id="myTabContent">
      {profReference.checksDetails &&
          Object.entries(profReference.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;
            const caseCheckId = value.case_check_id;
            const emp_check_id =
              profReference.REFERENCE_EMP_RELATION[value.check_id];
            let company_name = "";
            if (profReference.empChecks[emp_check_id] >= 1) {
              if (
                typeof profReference.empCompanies[emp_check_id] !==
                  "undefined" &&
                profReference.empCompanies[emp_check_id] != null &&
                typeof profReference.empCompanies[emp_check_id][key] !==
                  "undefined" &&
                profReference.empCompanies[emp_check_id][key] != null
              ) {   
                company_name = profReference.empCompanies[emp_check_id][key];
              } else {
                if (
                  typeof profReference.empCompanies[emp_check_id] !==
                    "undefined" &&
                  profReference.empCompanies[emp_check_id] != null
                ) {
                  company_name = profReference.empCompanies[emp_check_id];
                }
              }
            }

            let refData1 = "";
            let refData2 = "";
            if (
              typeof referenceData1 !== "undefined" &&
              referenceData1 != null
            ) {
              refData1 = referenceData1[caseCheckId];
              console.log(refData1);
            }
            if (
              typeof referenceData2 !== "undefined" &&
              referenceData2 != null
            ) {
              refData2 = referenceData2[caseCheckId];
            }
            let activeClass = "";
            if (typeof active !== "undefined") {
              if (active == caseCheckId) {
                activeClass = "show active";
              }
            } else if (index === 1) {
              activeClass = "show active";
            }

            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`profRef-${index}`}
                role="tabpanel"
                aria-labelledby={`profRef-tab-${index}`}
                key={key}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span></span>
                  {index !== 1 && profReference.is_custom_prof_ref == 1 && (
                    <button
                      class="btn btn-outline-secondary mt-3 mr-2"
                      onClick={(e) => handleProfRefRemoveClick(e, caseCheckId)}
                    >
                      <i class="far fa-trash-alt mr-2"></i>
                      Remove
                    </button>
                  )}
                </div>
                <div className="row">
                  {value.fields.company_name ? (
                    profReference.empChecks[emp_check_id] >= 1 ? (
                      <>
                        <ABText
                          caseId={caseCheckId}
                          label={value.fields.company_name.label}
                          id={`company_name_${caseCheckId}`}
                          name={`company_name_${caseCheckId}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.company_name.id}
                          inputText={selectHandler}
                          value={company_name}
                          isReadonly={1}
                          isRequired={value.fields.company_name.is_mandatory}
                          errId={`err_${caseCheckId}_${value.fields.company_name.id}`}
                        />
                      </>
                    ) : (
                      <>
                        <ABText
                          caseId={caseCheckId}
                          label={value.fields.company_name.label}
                          id={`company_name_${caseCheckId}`}
                          name={`company_name_${caseCheckId}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.company_name.id}
                          inputText={selectHandler}
                          isRequired={value.fields.company_name.is_mandatory}
                          value={value.fields.company_name.field_value}
                          errId={`err_${caseCheckId}_${value.fields.company_name.id}`}
                        />
                        {value.fields.company_designation ? (
                          <ABText
                            caseId={caseCheckId}
                            label={value.fields.company_designation.label}
                            id={`company_designation_${caseCheckId}`}
                            name={`company_designation_${caseCheckId}`}
                            divClass="col-sm-4 col-md-12 col-xl-4"
                            fieldId={value.fields.company_designation.id}
                            inputText={selectHandler}
                            isRequired={
                              value.fields.company_designation.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.company_designation.id}`}
                            value={value.fields.company_designation.field_value}
                          />
                        ) : (
                          <></>
                        )}
                        {value.fields.company_department ? (
                          <ABText
                            caseId={caseCheckId}
                            label={value.fields.company_department.label}
                            id={`company_department_${caseCheckId}`}
                            name={`company_department_${caseCheckId}`}
                            divClass="col-sm-4 col-md-12 col-xl-4"
                            fieldId={value.fields.company_department.id}
                            inputText={selectHandler}
                            isRequired={
                              value.fields.company_department.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.company_department.id}`}
                            value={value.fields.company_department.field_value}
                          />
                        ) : (
                          <></>
                        )}
                        {value.fields.company_date_joining ? (
                          <ABDate
                            caseId={caseCheckId}
                            paramStartDate={
                              value.fields.company_date_joining.field_value
                            }
                            placeholder={
                              value.fields.company_date_joining.label
                            }
                            name={`company_date_joining_${caseCheckId}`}
                            id={`company_date_joining_${caseCheckId}`}
                            fieldId={value.fields.company_date_joining.id}
                            isRequired={
                              value.fields.company_date_joining.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.company_date_joining.id}`}
                            intialStatus={0}
                            dateSelect={selectHandler}
                            maxDate={maxDate}
                            fieldName={`company_date_joining`}
                          />
                        ) : (
                          <></>
                        )}
                        {value.fields.company_date_of_leaving ? (
                          <ABDate
                            caseId={caseCheckId}
                            paramStartDate={
                              value.fields.company_date_of_leaving.field_value
                            }
                            placeholder={
                              value.fields.company_date_of_leaving.label
                            }
                            name={`company_date_of_leaving_${caseCheckId}`}
                            id={`company_date_of_leaving_${caseCheckId}`}
                            fieldId={value.fields.company_date_of_leaving.id}
                            isRequired={
                              value.fields.company_date_of_leaving.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.company_date_of_leaving.id}`}
                            intialStatus={0}
                            dateSelect={selectHandler}
                            minimumDate={
                              newRecord[value.fields.company_date_joining.id]
                            }
                            fieldName={`company_date_of_leaving`}
                          />
                        ) : (
                          <></>
                        )}
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </div>
                <label className="fnt-smi-bld d-block w-100">Reference 1</label>
                <div className="row">
                  {value.fields.reference_level  && clientId != "394129" ? (
                    <>
                      <ABRadioProfRef1
                        caseCheckId={caseCheckId}
                        name={`reference_level_${caseCheckId}`}
                        id={`reference_level_${caseCheckId}`}
                        inputText={selectHandler}
                        fieldId={value.fields.reference_level.id}
                        value={value.fields.reference_level.field_value1}
                        isRequired={value.fields.reference_level.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.reference_level.id}`}
                      />
                    </>
                  ) : (
                    <p className="col-12">Please provide reference from only a senior employee of the organization than applicant.</p>
                  )}
                  {value.fields.reference_name ? (
                    <ABText
                      caseId={caseCheckId}
                      label={value.fields.reference_name.label}
                      id={`reference_name_${caseCheckId}`}
                      name={`reference_name_${caseCheckId}`}
                      divClass="col-sm-4 col-md-12 col-xl-4"
                      fieldId={value.fields.reference_name.id}
                      inputText={selectHandler}
                      isRequired={value.fields.reference_name.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.reference_name.id}`}
                      value={
                        typeof refData1 !== "undefined" &&
                        refData1 != null &&
                        typeof refData1[129] !== "undefined" &&
                        refData1[129] !== null &&
                        typeof refData1[129][0] !== "undefined" &&
                        refData1[129][0] !== ""
                          ? refData1[129][0].stated_data
                          : ""
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.reference_designation ? (
                    <ABText
                      caseId={caseCheckId}
                      label={value.fields.reference_designation.label}
                      id={`reference_designation_${caseCheckId}`}
                      name={`reference_designation_${caseCheckId}`}
                      divClass="col-sm-4 col-md-12 col-xl-4"
                      fieldId={value.fields.reference_designation.id}
                      inputText={selectHandler}
                      isRequired={
                        value.fields.reference_designation.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.reference_designation.id}`}
                      value={
                        typeof refData1 !== "undefined" &&
                        refData1 != null &&
                        refData1[130] !== null &&
                        typeof refData1[130] !== "undefined" &&
                        typeof refData1[130][0] !== "undefined" &&
                        refData1[130][0] !== ""
                          ? refData1[130][0].stated_data
                          : ""
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.reference_email ? (
                    <ABText
                      caseId={caseCheckId}
                      label={value.fields.reference_email.label}
                      id={`reference_email_${caseCheckId}`}
                      name={`reference_email_${caseCheckId}`}
                      divClass="col-sm-4 col-md-12 col-xl-4"
                      fieldId={value.fields.reference_email.id}
                      inputText={selectHandler}
                      isRequired={value.fields.reference_email.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.reference_email.id}`}
                      value={
                        typeof refData1 !== "undefined" &&
                        refData1 != null &&
                        refData1[132] !== null &&
                        typeof refData1[132] !== "undefined" &&
                        typeof refData1[132][0] !== "undefined" &&
                        refData1[132][0] !== ""
                          ? refData1[132][0].stated_data
                          : ""
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.reference_mobile ? (
                    <ABText
                      caseId={caseCheckId}
                      label={value.fields.reference_mobile.label}
                      id={`reference_mobile_${caseCheckId}`}
                      name={`reference_mobile_${caseCheckId}`}
                      divClass="col-sm-4 col-md-12 col-xl-4"
                      fieldId={value.fields.reference_mobile.id}
                      inputText={selectHandler}
                      isRequired={value.fields.reference_mobile.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.reference_mobile.id}`}
                      value={
                        typeof refData1 !== "undefined" &&
                        refData1 != null &&
                        refData1[131] !== null &&
                        typeof refData1[131] !== "undefined" &&
                        typeof refData1[131][0] !== "undefined" &&
                        refData1[131][0] !== ""
                          ? refData1[131][0].stated_data
                          : ""
                      }
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.reference_best_time_to_reach ? (
                    <ABSelect
                      type={1}
                      id={`reference_best_time_to_reach_${caseCheckId}`}
                      name={`reference_best_time_to_reach_${caseCheckId}`}
                      placeholder="Best Time to Reach"
                      options={bestTimeToReach}
                      caseCheckId={caseCheckId}
                      fieldId={value.fields.reference_best_time_to_reach.id}
                      selectOption={selectHandler}
                      isRequired={
                        value.fields.reference_best_time_to_reach.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value.fields.reference_best_time_to_reach.id}`}
                      //value={bestTimeToReach[0]}
                      value={
                        value.fields.reference_best_time_to_reach.field_value1
                      }
                      //value={(typeof refData1 !== "undefined" && refData1 != null && refData1[133] !== null && typeof refData1[133] !== "undefined" && typeof refData1[133][0] !== "undefined" && refData1[133][0] !== '')  ? refData1[133][0].stated_data : ''}
                      // selectedLabel={(typeof refData1 !== "undefined" && refData1 != null && refData1[133] !== null && typeof refData1[133] !== "undefined" && typeof refData1[133][0] !== "undefined" && refData1[133][0] !== '')  ? refData1[133][0].stated_data : ''}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                {index == 1 ||
                (index == 2 &&
                  profReference.isCurrent == 1 &&
                  value.is_added != 1) ? (
                  <>
                    <label className="fnt-smi-bld d-block w-100">
                      Reference 2
                    </label>
                    <div className="row">
                      {value.fields.reference_level  && clientId != "394129" ? (
                        <>
                          <ABRadioProfRef2
                            caseCheckId={caseCheckId}
                            name={`reference_level_1_${caseCheckId}`}
                            id={`reference_level_1_${caseCheckId}`}
                            inputText={selectHandler}
                            fieldId={value.fields.reference_level.id}
                            value={value.fields.reference_level.field_value2}
                            isRequired={
                              value.fields.reference_level.is_mandatory
                            }
                            errId={`err_${caseCheckId}_${value.fields.reference_level.id}_1`}
                          />
                        </>
                      ) : (
                        <p className="col-12">Please provide reference from only a senior employee of the organization than applicant.</p>
                      )}
                      {value.fields.reference_name ? (
                        <ABText
                          caseId={caseCheckId}
                          label={value.fields.reference_name.label}
                          id={`reference_name_1_${caseCheckId}`}
                          name={`reference_name_1_${caseCheckId}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.reference_name.id}
                          inputText={selectHandler}
                          isRequired={value.fields.reference_name.is_mandatory}
                          errId={`err_${caseCheckId}_${value.fields.reference_name.id}_1`}
                          value={
                            typeof refData2 !== "undefined" &&
                            refData2 != null &&
                            refData2[129] !== null &&
                            typeof refData2[129] !== "undefined" &&
                            typeof refData2[129][1] !== "undefined" &&
                            refData2[129][1] !== ""
                              ? refData2[129][1].stated_data
                              : ""
                          }
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.reference_designation ? (
                        <ABText
                          caseId={caseCheckId}
                          label={value.fields.reference_designation.label}
                          id={`reference_designation_1_${caseCheckId}`}
                          name={`reference_designation_1_${caseCheckId}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.reference_designation.id}
                          inputText={selectHandler}
                          isRequired={
                            value.fields.reference_designation.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.reference_designation.id}_1`}
                          value={
                            typeof refData2 !== "undefined" &&
                            refData2 != null &&
                            refData2[130] !== null &&
                            typeof refData2[130] !== "undefined" &&
                            typeof refData2[130][1] !== "undefined" &&
                            refData2[130][1] !== ""
                              ? refData2[130][1].stated_data
                              : ""
                          }
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.reference_email ? (
                        <ABText
                          caseId={caseCheckId}
                          label={value.fields.reference_email.label}
                          id={`reference_email_1_${caseCheckId}`}
                          name={`reference_email_1_${caseCheckId}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.reference_email.id}
                          inputText={selectHandler}
                          isRequired={value.fields.reference_email.is_mandatory}
                          errId={`err_${caseCheckId}_${value.fields.reference_email.id}_1`}
                          value={
                            typeof refData2 !== "undefined" &&
                            refData2 != null &&
                            refData2[132] !== null &&
                            typeof refData2[132] !== "undefined" &&
                            typeof refData2[132][1] !== "undefined" &&
                            refData2[132][1] !== ""
                              ? refData2[132][1].stated_data
                              : ""
                          }
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.reference_mobile ? (
                        <ABText
                          caseId={caseCheckId}
                          label={value.fields.reference_mobile.label}
                          id={`reference_mobile_1_${caseCheckId}`}
                          name={`reference_mobile_1_${caseCheckId}`}
                          divClass="col-sm-4 col-md-12 col-xl-4"
                          fieldId={value.fields.reference_mobile.id}
                          inputText={selectHandler}
                          isRequired={
                            value.fields.reference_mobile.is_mandatory
                          }
                          errId={`err_${caseCheckId}_${value.fields.reference_mobile.id}_1`}
                          value={
                            typeof refData2 !== "undefined" &&
                            refData2 != null &&
                            refData2[131] !== null &&
                            typeof refData2[131] !== "undefined" &&
                            typeof refData2[131][1] !== "undefined" &&
                            refData2[131][1] !== ""
                              ? refData2[131][1].stated_data
                              : ""
                          }
                        />
                      ) : (
                        <></>
                      )}
                      {value.fields.reference_best_time_to_reach ? (
                        <ABSelect
                          caseCheckId={caseCheckId}
                          type={1}
                          id={`reference_best_time_to_reach_1_${caseCheckId}`}
                          name={`reference_best_time_to_reach_1_${caseCheckId}`}
                          placeholder="Best Time to Reach"
                          options={bestTimeToReach}
                          fieldId={value.fields.reference_best_time_to_reach.id}
                          selectOption={selectHandler}
                          errId={`err_${caseCheckId}_${value.fields.reference_best_time_to_reach.id}_1`}
                          isRequired={
                            value.fields.reference_best_time_to_reach
                              .is_mandatory
                          }
                          value={
                            value.fields.reference_best_time_to_reach
                              .field_value2
                          }
                          // value={(typeof refData2 !== "undefined" && refData2 != null && refData2[133] !== null && typeof refData2[133] !== "undefined" && typeof refData2[133][1] !== "undefined" && refData2[133][1] !== '')  ? refData2[133][1].stated_data : ''}
                          // selectedLabel={(typeof refData2 !== "undefined" && refData2 != null && refData2[133] !== null && typeof refData2[133] !== "undefined" && typeof refData2[133][0] !== "undefined" && refData2[133][0] !== '')  ? refData2[133][1].stated_data : ''}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button> */}
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) => saveHandler(e, caseCheckId, index)}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {profReference.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                      {clientId == 459831 ? "Preview" : "Submit for Preview"}                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};
export default MainForm;
